import { freezeMap } from "./helpers.js";

const europeanCountries = [
  { value: "EU", text: "European Union", flag: "🇪🇺", region: "EU Average", isEU: true },
  { value: "AL", text: "Albania", flag: "🇦🇱", isEU: false },
  { value: "AT", text: "Austria", flag: "🇦🇹", region: "Region 1", isEU: true },
  { value: "BE", text: "Belgium", flag: "🇧🇪", region: "Region 2", isEU: true },
  { value: "BA", text: "Bosnia and Herzegovina", flag: "🇧🇦", isEU: false },
  { value: "BG", text: "Bulgaria", flag: "🇧🇬", region: "Region 3", isEU: true },
  { value: "HR", text: "Croatia", flag: "🇭🇷", region: "Region 3", isEU: true },
  { value: "CY", text: "Cyprus", flag: "🇨🇾", isEU: true },
  { value: "CZ", text: "Czech Republic", flag: "🇨🇿", region: "Region 1", isEU: true },
  { value: "DK", text: "Denmark", flag: "🇩🇰", region: "Region 1", isEU: true },
  { value: "EE", text: "Estonia", flag: "🇪🇪", isEU: true },
  { value: "FI", text: "Finland", flag: "🇫🇮", region: "Region 1", isEU: true },
  { value: "FR", text: "France", flag: "🇫🇷", region: "Region 2", isEU: true },
  { value: "DE", text: "Germany", flag: "🇩🇪", region: "Region 2", isEU: true },
  { value: "EL", text: "Greece", flag: "🇬🇷", isEU: true },
  { value: "HU", text: "Hungary", flag: "🇭🇺", region: "Region 1", isEU: true },
  { value: "IS", text: "Iceland", flag: "🇮🇸", isEU: false },
  { value: "IE", text: "Ireland", flag: "🇮🇪", isEU: true },
  { value: "IT", text: "Italy", flag: "🇮🇹", region: "Region 3", isEU: true },
  { value: "LV", text: "Latvia", flag: "🇱🇻", isEU: true },
  { value: "LI", text: "Liechtenstein", flag: "🇱🇮", isEU: false },
  { value: "LT", text: "Lithuania", flag: "🇱🇹", region: "Region 1", isEU: true },
  { value: "LU", text: "Luxembourg", flag: "🇱🇺", isEU: true },
  { value: "MT", text: "Malta", flag: "🇲🇹", isEU: true },
  { value: "MD", text: "Moldova", flag: "🇲🇩", isEU: false },
  { value: "ME", text: "Montenegro", flag: "🇲🇪", isEU: false },
  { value: "NL", text: "Netherlands", flag: "🇳🇱", region: "Region 2", isEU: true },
  { value: "MK", text: "North Macedonia", flag: "🇲🇰", isEU: false },
  { value: "NO", text: "Norway", flag: "🇳🇴", isEU: false },
  { value: "PL", text: "Poland", flag: "🇵🇱", region: "Region 1", isEU: true },
  { value: "PT", text: "Portugal", flag: "🇵🇹", region: "Region 3", isEU: true },
  { value: "RO", text: "Romania", flag: "🇷🇴", region: "Region 3", isEU: true },
  { value: "RS", text: "Serbia", flag: "🇷🇸", isEU: false },
  { value: "SK", text: "Slovakia", flag: "🇸🇰", region: "Region 1", isEU: true },
  { value: "SI", text: "Slovenia", flag: "🇸🇮", isEU: true },
  { value: "ES", text: "Spain", flag: "🇪🇸", region: "Region 3", isEU: true },
  { value: "SE", text: "Sweden", flag: "🇸🇪", region: "Region 1", isEU: true },
  { value: "CH", text: "Switzerland", flag: "🇨🇭", isEU: false },
  { value: "UA", text: "Ukraine", flag: "🇺🇦", isEU: false },
  { value: "UK", text: "United Kingdom", flag: "🇬🇧", isEU: false },
];

export { europeanCountries };

export const EU_COUNTRIES = Object.freeze(europeanCountries.filter((country) => country.isEU === true));

export const CountriesMap = freezeMap(new Map(europeanCountries.map((c) => [c.value, c])));
export const EU_COUNTRIES_MAP = freezeMap(new Map(EU_COUNTRIES.map((c) => [c.value, c])));
export const EU_COUNTRIES_BY_TEXT = freezeMap(new Map(EU_COUNTRIES.map((c) => [c.text, c])));
export const EUROPEAN_COUNTRIES_BY_TEXT = freezeMap(new Map(europeanCountries.map((c) => [c.text, c])));

export const EFSA_COUNTRIES = Object.freeze(["Austria", "Belgium", "Bulgaria", "Croatia", "Denmark", "France", "Germany", "Greece", "Ireland", "Italy", "Lithuania", "Luxembourg", "Netherlands", "Poland", "Portugal", "Republic of north macedonia", "Romania", "Serbia", "Slovakia", "Spain", "Ukraine", "United kingdom"]);
